// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"66":"4f465b9c","99":"fa976d19","166":"a9341e52","313":"5b2688ca","350":"b293c306","565":"b137878b","712":"5c5f298a","751":"6ee09f97","761":"2a198725","915":"1eb5e4db","922":"8f4247b2"}[chunkId] + ".js";
};